import { BundlesTypes } from './types'
import { Action } from '../types'
import { Bundle } from '../../types/bundles'

type BundleAction = Action<BundlesTypes, Bundle[]>

const initialState: Bundle[] = []

export function bundlesReducer(
  state = initialState,
  action: BundleAction
): Bundle[] {
  switch (action.type) {
    case BundlesTypes.SAVE_BUNDLES:
      return [...state, ...action.payload]
    default:
      return state
  }
}
